<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" fill="none" viewBox="0 0 18 19"><path fill="#000" d="M9 1.5c-1.856.002-3.635.706-4.947 1.958C2.74 4.71 2.003 6.408 2 8.178a6.415 6.415 0 0 0 1.41 4.008s.191.24.222.274L9 18.5l5.37-6.043c.028-.032.22-.271.22-.271v-.002A6.413 6.413 0 0 0 16 8.179c-.002-1.771-.74-3.469-2.053-4.72C12.635 2.205 10.856 1.501 9 1.5Zm0 9.107c-.503 0-.996-.142-1.414-.41a2.457 2.457 0 0 1-.938-1.089 2.325 2.325 0 0 1-.145-1.403c.099-.471.341-.904.697-1.244.356-.34.81-.57 1.303-.664a2.66 2.66 0 0 1 1.471.138c.465.184.863.495 1.143.894.28.4.428.87.428 1.35 0 .643-.269 1.26-.746 1.716A2.612 2.612 0 0 1 9 10.607Z"/></svg>
</template>

<script>
export default {
  name: "GeoPointIcon"
}
</script>